/**
 * Full JSON-LD schema array for /x-ploration-jazz: the bookable MusicGroup
 * entity followed by the embedded "Hear the group" VideoObject (#34
 * convention).
 *
 * Previously lived inline in app.routes.ts's static route data. Moved here
 * 2026-09-14 so it's set at runtime via SEOService — see
 * XPlorationJazzContentComponent — inside this route's own lazy chunk
 * instead of the eager route-data bundle.
 */
export function buildXPlorationJazzPageSchemas(): Record<string, unknown>[] {
  return [
    // The bookable entity itself. This page's whole job is being found by
    // event planners, so the group gets a first-class MusicGroup node
    // rather than living only as prose inside WebPage. Per Russ
    // (2026-07-11), availability is regional — around South Florida — so
    // no broader nationwide areaServed is asserted here.
    {
      '@type': 'MusicGroup',
      name: 'X-Ploration Jazz',
      url: 'https://www.russrodgersbassguitar.com/x-ploration-jazz',
      genre: ['Jazz'],
      description:
        'A three to five piece jazz group led by bassist Russ Rodgers, performing at corporate events, receptions, galas, and private gatherings.',
      member: {
        '@type': 'OrganizationRole',
        member: {
          '@type': 'Person',
          name: 'Russ Rodgers',
          url: 'https://www.russrodgersbassguitar.com/about/bio',
        },
        roleName: 'Bandleader, bass guitar',
      },
      // Regional, deliberately: per Russ the group works around South
      // Florida, not nationally (2026-07-11, re-confirmed 2026-08-09 and
      // again 2026-08-11) — matches the hero lede and booking copy.
      // NOTE this SUPERSEDES the #72 archive line saying the group is
      // "bookable anywhere in the continental US"; that is no longer true,
      // so do not widen this back on the strength of that entry.
      areaServed: {
        '@type': 'Place',
        name: 'South Florida',
      },
    },
    // The embedded "Hear the group" performance (#34 convention).
    {
      '@type': 'VideoObject',
      name: 'Mean To Me with vocalist Flo Anito',
      description:
        'Live jazz performance of Mean To Me with vocalist Flo Anito, with Russ Rodgers on bass.',
      thumbnailUrl: 'https://i.ytimg.com/vi/QC1mb3vwon0/hqdefault.jpg',
      uploadDate: '2025-11-20T12:00:00+00:00',
      duration: 'PT6M15S',
      contentUrl: 'https://www.youtube.com/watch?v=QC1mb3vwon0',
      embedUrl: 'https://www.youtube.com/embed/QC1mb3vwon0',
    },
  ];
}
